import { render, staticRenderFns } from "./CryptoAccountBody.vue?vue&type=template&id=15a16dac&scoped=true&"
import script from "./CryptoAccountBody.vue?vue&type=script&lang=ts&"
export * from "./CryptoAccountBody.vue?vue&type=script&lang=ts&"
import style0 from "./CryptoAccountBody.vue?vue&type=style&index=0&id=15a16dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a16dac",
  null
  
)

export default component.exports